import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { fuseAnimations } from '@fuse/animations';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { lang_changelog } from 'app/idiomas/i18n/changelog/changelog.lang';
import { LogActualizacionesService } from "./log-actualizaciones.service";

const moment = require('moment');

@Component({
  selector: 'app-log-actualizaciones',
  templateUrl: './log-actualizaciones.component.html',
  styleUrls: ['./log-actualizaciones.component.scss'],
  animations   : fuseAnimations
})
export class LogActualizacionesComponent implements OnInit {

  versiones: any;
  idiomaActual: string;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private las: LogActualizacionesService
  ) {
    lang_changelog.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.idiomaActual = this.translateSrv.currentLang;
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
  }

  ngOnInit(): void {
    this.las.getChangelog().subscribe((respuesta:any) => {
      console.log("getChangelog:",respuesta);
      if(respuesta.success){
        this.versiones = respuesta.versions;
        this.versiones.sort( (a,b) => {
          if(moment(a.createdAt).isBefore(moment(b.createdAt))){ return 1; } else{ return -1; }
        });
      }
    });
  }

}
